import React from 'react';
import { NavToggle } from '../toggle';
import { CartHeader, CartHeading, CartSubHeader } from './style';

const CartHead = ({ itemsCount, onCartClose }) => (
  <CartHeader>
    <CartHeading>
      Ihr Warenkorb
      <CartSubHeader>{itemsCount} Artikel</CartSubHeader>
    </CartHeading>
    <NavToggle
      onClick={onCartClose}
      isExpanded={true}
      color="rgba(129, 132, 145, 1)"
    />
  </CartHeader>
);

export default CartHead;



// WEBPACK FOOTER //
// ./src/components/cart/cartHeader.js